import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const FixedWirelessHeaderSection = ({ getAggregatedAddress, normalizedAddress, onResetAddress }) => {
  const {t} = useTranslation();
  return (
    <div className="internet-result-heading internetOuterClass">
      <div className="elink-container">
        <div className="elnk-internet-heading">
          <h1 className="elnk-internet-heading__title">
            {t('business.heading')}
          </h1>
          <p className="elnk-internet-heading__address">
            <span className="address-txt">{getAggregatedAddress(normalizedAddress)}</span>
            <button className="address-btn" type="button" onClick={onResetAddress}>
              <i className="fa-solid fa-pen-to-square address-edit-icon" aria-hidden="true"></i> Edit
            </button>
          </p>
        </div>
      </div>
    </div>
  )
};

FixedWirelessHeaderSection.propTypes = {
  getAggregatedAddress: PropTypes.func.isRequired,
  normalizedAddress: PropTypes.object.isRequired,
  onResetAddress: PropTypes.func.isRequired,
};

export default FixedWirelessHeaderSection;
